import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TendersComponent } from './components/tenders/tenders.component';
import { TenderComponent } from './components/tender/tender.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { QuestionsComponent } from './components/questions/questions.component';

const routes: Routes = [
  //{ path: '', component: TendersComponent, pathMatch:'full' },
  { path: 'tender/:id', component: TenderComponent},
  { path: 'registration/:id', component: RegistrationComponent},
  { path: 'questions/:id', component: QuestionsComponent},
  //{ path: 'tenders', component: TendersComponent },
  //{ path: 'tender', component: TenderComponent},
  //{ path: 'registration/:id', component: RegistrationComponent},
  //{ path: 'questions/:id', component: QuestionsComponent},
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
